const DecimalCounts = [0, 1, 2, 3, 4, 5, "default"];
export let ThousandsSeparator;
(function (ThousandsSeparator) {
  ThousandsSeparator["COMMA"] = "comma";
  ThousandsSeparator["NONE"] = "none";
})(ThousandsSeparator || (ThousandsSeparator = {}));
export let NumberFormat;
(function (NumberFormat) {
  NumberFormat["CURRENCY"] = "currency";
  NumberFormat["NONE"] = "none";
  NumberFormat["NUMBER"] = "number";
  NumberFormat["PERCENT"] = "percent";
})(NumberFormat || (NumberFormat = {}));
export let NegativeStyle;
(function (NegativeStyle) {
  NegativeStyle["NONE"] = "none";
  NegativeStyle["PAREN_BLACK"] = "parenBlack";
  NegativeStyle["PAREN_RED"] = "parenRed";
  NegativeStyle["SIGN_BLACK"] = "signBlack";
  NegativeStyle["SIGN_RED"] = "signRed";
})(NegativeStyle || (NegativeStyle = {}));
//# sourceMappingURL=Number.js.map